import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { ChartLineUp } from "@phosphor-icons/react";

export default function Usage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: projects } = await api.get("/projects");
        const live = projects.filter((p) => p.status === "live");
        const results = await Promise.all(live.map(async (p) => {
          try { const { data } = await api.get(`/projects/${p.id}/usage`); return { p, u: data }; }
          catch { return null; }
        }));
        setRows(results.filter(Boolean));
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-6 py-10 sm:px-10">
        <h1 className="font-display text-4xl font-bold tracking-tight">Usage</h1>
        <p className="mt-2 text-muted-foreground">A simple view of what your apps are using.</p>

        {!loading && rows.length === 0 && (
          <div className="mt-8 rounded-3xl border border-dashed border-border bg-card p-12 text-center">
            <ChartLineUp size={36} weight="duotone" className="mx-auto text-muted-foreground" />
            <p className="mt-4 text-muted-foreground">No live apps yet. Usage appears once you deploy.</p>
          </div>
        )}

        <div className="mt-8 space-y-4">
          {rows.map(({ p, u }, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              className="rounded-2xl border border-border bg-card p-6" data-testid={`usage-${p.id}`}>
              <div className="flex items-center justify-between">
                <p className="font-display text-lg font-medium">{p.name}</p>
                <span className="rounded-full bg-secondary px-3 py-1 text-xs font-semibold capitalize">{u.plan} plan</span>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
                <div><p className="font-display text-xl font-bold">{u.usage.cpu_pct}%</p><p className="text-xs text-muted-foreground">CPU</p></div>
                <div><p className="font-display text-xl font-bold">{u.usage.ram_pct}%</p><p className="text-xs text-muted-foreground">Memory</p></div>
                <div><p className="font-display text-xl font-bold">{u.usage.storage_mb ?? 0} MB</p><p className="text-xs text-muted-foreground">Storage</p></div>
                <div><p className="font-display text-xl font-bold">{u.usage.collections ?? 0}</p><p className="text-xs text-muted-foreground">Collections</p></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
